import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Blog.css";
import Footer from "../Footer";
import placeholder from "./assets/image.png";
import arrowIcon from "./assets/svg/arrow.svg";
import dateIcon from "./assets/svg/date.svg";

const decodeEntities = (str) => {
  const txt = document.createElement("textarea");
  txt.innerHTML = str;
  return txt.value;
};

const getExcerpt = (post, length = 180) => {
  const raw = post.excerpt?.rendered ?? "";
  const stripped = raw.replace(/<[^>]+>/g, "");
  return decodeEntities(stripped).substring(0, length) + "…";
};

const hasCropTag = (post) => {
  const tags =
    post?._embedded?.["wp:term"]
      ?.flat()
      ?.filter((t) => t.taxonomy === "post_tag") ?? [];

  return tags.some((t) => t.slug === "crop" || t.name === "crop");
};

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);

    const fetchBlogPosts = async () => {
      try {
        setLoading(true);

        const categoryRes = await fetch(
          "https://beszeljegyesulet.hu/wp/wp-json/wp/v2/categories?slug=blog"
        );

        const categories = await categoryRes.json();
        const blogCategory = Array.isArray(categories) ? categories[0] : null;

        if (!blogCategory?.id) {
          setPosts([]);
          return;
        }

        const postsRes = await fetch(
          `https://beszeljegyesulet.hu/wp/wp-json/wp/v2/posts?_embed&per_page=12&categories=${blogCategory.id}`
        );

        const postsData = await postsRes.json();
        setPosts(Array.isArray(postsData) ? postsData : []);
      } catch (err) {
        console.error("Blog posts error:", err);
        setPosts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogPosts();
  }, []);

  return (
    <main className="blog-page">
      <section className="blog-hero">
        <div className="blog-hero-container">
          <h1>Blog</h1>
        </div>
      </section>

      <section className="blog-list-section">
        <div className="blog-list-container">
          {loading ? (
            <div className="blog-loading">Betöltés...</div>
          ) : posts.length === 0 ? (
            <div className="blog-empty">
              Jelenleg nincsenek blogbejegyzések.
            </div>
          ) : (
            <div className="blog-grid">
              {posts.map((post) => {
                const featured =
                  post._embedded?.["wp:featuredmedia"]?.[0]?.source_url ||
                  placeholder;

                const crop = hasCropTag(post);

                return (
                  <article className="blog-card" key={post.id}>
                    <Link
                      to={`/posts/${post.slug}`}
                      className="blog-image-link"
                    >
                      <div
                        className={`blog-image-frame ${
                          crop ? "blog-image-frame--crop" : ""
                        }`}
                      >
                        {!crop && (
                          <div
                            className="blog-image-blur"
                            style={{ backgroundImage: `url(${featured})` }}
                            aria-hidden="true"
                          />
                        )}

                        <img
                          src={featured}
                          alt={decodeEntities(post.title.rendered)}
                          className={`blog-image ${
                            crop ? "blog-image--crop" : ""
                          }`}
                        />
                      </div>
                    </Link>

                    <div className="blog-card-content">
                      <div className="blog-meta">
                        <img src={dateIcon} alt="Dátum" />
                        <span>
                          {new Date(post.date).toLocaleDateString("hu-HU", {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                          })}
                        </span>
                      </div>

                      <Link
                        to={`/posts/${post.slug}`}
                        className="blog-title-link"
                      >
                        <h2
                          className="heading-md"
                          dangerouslySetInnerHTML={{
                            __html: post.title.rendered,
                          }}
                        />
                      </Link>

                      <p>{getExcerpt(post)}</p>

                      <Link
                        to={`/posts/${post.slug}`}
                        className="blog-read-more"
                      >
                        Tovább{" "}
                        <img
                          src={arrowIcon}
                          alt="nyíl ikon"
                          className="arrow-icon"
                        />
                      </Link>
                    </div>
                  </article>
                );
              })}
            </div>
          )}
        </div>
      </section>

      <Footer />
    </main>
  );
}